<template>
  <div>
    <con-tab ></con-tab>
    <!-- 在线咨询 -->
    <zixunNei></zixunNei>
  </div>
</template>

<script>
import ConTab from "../../components/common/ConTab";
import zixunNei from "./base/zixunNei";
 export default {
  name: "zixun",
  data() {
    return {};
  },
  created() {},
  methods: {
    TwoClick(item) {
      this.ConList = item;
    },
  },
  components: {
    ConTab,
    zixunNei,
  },
};
</script>

<style scoped>
</style>
